import { render, staticRenderFns } from "./SpecimenSourceList.vue?vue&type=template&id=338f525c&"
import script from "./SpecimenSourceList.vue?vue&type=script&lang=js&"
export * from "./SpecimenSourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports